(() => {

  function hideSoldOutSwatches(root = document) {
    root.querySelectorAll('input[data-option-available="false"]').forEach(input => {
      const swatchItem = input.closest('.variant-option__swatch');

      if (swatchItem) {
        swatchItem.style.display = 'none';
      }
    });
  }

  // Initial run
  hideSoldOutSwatches();

  // Observe ALL swatch containers safely
  document.querySelectorAll('swatches-variant-picker-component, .product-form__variants')
    .forEach(container => {

      hideSoldOutSwatches(container);

      const observer = new MutationObserver(() => {
        hideSoldOutSwatches(container);
      });

      observer.observe(container, {
        childList: true,
        subtree: true
      });

    });

})();